module.exports = __webpack_public_path__ + "img/level_09_diamond.25ce050b.svg";